import API from "./api";
import store from "../store/";

function getBoasts() {
    const { channelId } = store.state;

    if (!channelId) {
        throw new Error("Missing required data for fetching initial state.");
    }

    const url = `/boasts/${channelId}`;
    return API.get(url);
}

function deleteBoast(key) {
    const { channelId } = store.state;

    if (!channelId) {
        throw new Error("Missing required data for fetching initial state.");
    }

    const url = `/boasts/${channelId}?boast_id=${channelId}&boast_ts=${key}`;
    return API.delete(url);
}

export default {
    getBoasts,
    deleteBoast
};
